import { render, staticRenderFns } from "./MamWalletTransferModal.vue?vue&type=template&id=e9082d56&scoped=true"
import script from "./MamWalletTransferModal.vue?vue&type=script&lang=js"
export * from "./MamWalletTransferModal.vue?vue&type=script&lang=js"
import style0 from "./MamWalletTransferModal.vue?vue&type=style&index=0&id=e9082d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9082d56",
  null
  
)

export default component.exports